import { addDays, getDay } from 'date-fns';

export const getNextWeekday = (date: Date, targetDay: number) => {
  const daysToAdd = (targetDay + 7 - getDay(date)) % 7 || 7;
  return addDays(date, daysToAdd);
};
